import SummativeAssessmentAndRejectedView from "../SummativeAssessmentAndRejectedView/SummativeAssessmentAndRejectedView"

const SummativeAssessmentView = ({
    submissionData,
    remarks,
    dynamicIndicatorObj,
    setEditData,
    nextAssessment,
    title1,
    title2,
    scoreAdditionalData }) => {

    return (
        <SummativeAssessmentAndRejectedView
            submissionData={submissionData}
            remarks={remarks}
            dynamicIndicatorObj={dynamicIndicatorObj}
            setEditData={setEditData}
            nextAssessment={nextAssessment}
            title1={title1}
            title2={title2}
            scoreAdditionalData={scoreAdditionalData}
        />
    )


}
export default SummativeAssessmentView